module.exports = __webpack_public_path__ + "13c4fd3db5be8fa32d5f20327b75d198.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_stacked_bar_1week.png
// module id = 886
// module chunks = 7